import { Col, Flex, Form, Input, InputRef, Modal, Row } from "antd"
import { useEffect, useRef, useState } from "react"
import { PricingTypes } from "../../../../common/constants"
import { useCreateWorkareaGroupMutation } from "../../../../domain/workareas/groupsQueries"
import RichTextEditor from "../../../RichTextEditor/RichTextEditor"
import PricingTypeSelector from "../EditorDrawer/WorkareaEditor/PricingTypeSelector"

type Props = {
  isOpen: boolean
  onClose: () => void
  jobId: number
  onGroupCreated?: (groupId: string) => void
}

const CreateWorkareaGroupModal = ({ isOpen, onClose, jobId, onGroupCreated }: Props) => {
  const [name, setName] = useState('')
  const [pricingType, setPricingType] = useState(PricingTypes.QuotedPrice)
  const [description, setDescription] = useState('')
  const autoFocusRef = useRef<InputRef>(null);

  const createWorkareaGroupMutation = useCreateWorkareaGroupMutation((groupId) => {
    onGroupCreated?.(groupId)
    onClose()
  })
  const isMutating = createWorkareaGroupMutation.isLoading

  const handleSave = () => {
    createWorkareaGroupMutation.mutate({
      jobId,
      name: name,
      pricingType: pricingType,
      customerAndInvoiceNotes: description
    })
  }

  useEffect(() => {
    if (!isOpen) {
      setName('')
      setPricingType(PricingTypes.QuotedPrice)
      setDescription('')
    }
  }, [isOpen])

  const handleOpen = () => {
    if (autoFocusRef.current) {
      autoFocusRef.current.focus()
    }
  };

  return <Modal
    okText='Save'
    title='Create Work Area Group'
    open={isOpen}
    onCancel={onClose}
    onOk={handleSave}
    okButtonProps={{ disabled: !name || isMutating, loading: isMutating }}
    cancelButtonProps={{ disabled: isMutating }}
    afterOpenChange={handleOpen}
  >
    <Flex justify="" align="center" gap={20}>
      <Form
        layout="vertical"
        style={{ flex: 1 }}
      >
        <Row gutter={16}>
          <Col span={12}>
            <Form.Item label="Name">
              <Input
                ref={autoFocusRef}
                placeholder="Group Name"
                value={name}
                onChange={(e) => setName(e.target.value)}
                maxLength={100}
              />
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item label="Pricing Type">
              <PricingTypeSelector
                value={pricingType}
                onChange={setPricingType}
                canEditGroupFields={true}
                isPricingLocked={false}
                excludePerVisit={true}
                isApproved={false}/>
            </Form.Item>
          </Col>
        </Row>
        <Row>
          <Col span={24}>
            <Form.Item>
              <RichTextEditor
                value={description}
                onChange={(value) => setDescription(value)}
                style={{ backgroundColor: 'white' }}
                placeholder="Customer and Invoice Notes"
              />
            </Form.Item>
          </Col>
        </Row>
      </Form>
    </Flex>
  </Modal>
}

export default CreateWorkareaGroupModal
